import BaseRoute from "utils/base_route";
import DataAssetsOverview from "./containers/data_assets_overview";

export default class DataAssetsOverviewRoute extends BaseRoute {
  constructor(store) {
    super("overview", store);
  }

  getChildRoutes(state, cb) {
    cb(null, []);
  }
  getComponents(location, cb) {
    cb(null, DataAssetsOverview);
  }
}
